import pf21BusinessCodes from './pf21_business_codes.json'

interface PF21BusinessCodeRaw {
  code: string
  description: string
  category: string
}

interface PF21BusinessCodesDataset {
  source: string
  classification_system: string
  reference_url: string
  total_codes: number
  codes: PF21BusinessCodeRaw[]
}

interface NaicsCodeEntry {
  code: string
  description: string
  category: string
}

const dataset = pf21BusinessCodes as PF21BusinessCodesDataset

function sortByCode(a: NaicsCodeEntry, b: NaicsCodeEntry): number {
  return a.code.localeCompare(b.code)
}

const PF21_NAICS_CODES: NaicsCodeEntry[] = dataset.codes.map((entry) => ({
  code: entry.code,
  description: entry.description,
  category: entry.category,
}))

export const PF21_NAICS_CODES_SORTED: NaicsCodeEntry[] = [...PF21_NAICS_CODES].sort(sortByCode)

export const PF21_NAICS_CODES_BY_CATEGORY: Record<string, NaicsCodeEntry[]> = Object.fromEntries(
  Object.entries(
    PF21_NAICS_CODES.reduce<Record<string, NaicsCodeEntry[]>>((acc, entry) => {
      if (!acc[entry.category]) {
        acc[entry.category] = []
      }
      acc[entry.category].push(entry)
      return acc
    }, {}),
  )
    .sort(([categoryA], [categoryB]) => categoryA.localeCompare(categoryB))
    .map(([category, entries]) => [category, [...entries].sort(sortByCode)]),
)
